<template>
    <div>
        <el-form ref="form" :model="remindConfig" label-width="120px">
            
            
            <el-row>
                <el-col :span="12">
                   <el-form-item label="响铃间隔时间">
                        <el-input-number v-model="remindConfig.ringRate" :min="1" :max="1000" style="width: 180px;"></el-input-number>秒
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="电话间隔时间">
                        <el-input-number v-model="remindConfig.telRate" :min="600" :max="6000" style="width: 180px;"></el-input-number>秒
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="微信间隔时间">
                        <el-input-number v-model="remindConfig.wechatRate" :min="300" :max="6000" style="width: 180px;"></el-input-number>秒
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="企微间隔时间">
                        <el-input-number v-model="remindConfig.workChatRate" :min="30" :max="6000" style="width: 180px;"></el-input-number>秒
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="电脑铃声选择">
                        <el-select v-model="remindConfig.taskSound" placeholder="请选择" style="width: 180px;">
                            <el-option v-for="(item,index) in sounds" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    
                    <el-form-item label="">
                        <el-button type="primary"   @click="loadPerson">重载通讯录</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            
            <el-table :data="remindConfig.personList" min-height="250" style="width: 100%" border>
                <el-table-column label="姓名"  prop="name"></el-table-column>
                <el-table-column label="电话提醒" width="150" prop="useTel" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.useTel"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="微信提醒" width="150" prop="useWechat" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.useWechat" ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="企微提醒" width="150" prop="useWechat" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.useWorkChat" ></el-switch>
                    </template>
                </el-table-column>
            </el-table>

        </el-form>        

    </div>
</template>

<script>
    export default {
        name: 'RemindConfig',
        props: {
            task: Object,
            curTaskIndex: Number,
            soundsList:Array
        },
        data() {
            return {
                remindConfig: {
                    taskSound: '',
                    ringRate: 1,
                    telRate: 600,
                    wechatRate:300,
                    workChatRate:30,
                    personList: [{name: '当前用户', useTel: true, useWechat: true, useWorkChat: true},{name: '张三', useTel: true, useWechat: true, useWorkChat: true}]
                },
                sounds: []
                }
        },
        mounted() {
            this.remindConfig = this.task.remindConfig
            for(let i in this.soundsList){
                this.sounds.push({
                    label:this.soundsList[i],
                    value:this.soundsList[i],

                })

            }
        },
        created() {

        },
        beforeDestroy() {

        },
        methods: {
            async loadPerson(){
                let personal=await window.pywebview.api.getPersonal()
                console.log(personal)
                let persons=personal.personList
                this.remindConfig.personList=[]
                for(let i in persons){
                    this.remindConfig.personList.push({
                        name:persons[i].name,
                        useTel:true,
                        useWechat:true,
                        useWorkChat:true
                    })
                }
            }
        }


    }
</script>

<style scoped>

</style>